import utils from '@/utils/utils.js'

export default {
  // Load Feed Report Data
  async loadFeedReportData({ commit, state }, { startDate, endDate, queues = [], users = [], percentageSlice1 = 20, percentageSlice2 = 60 }) {
    commit('SET_LOADING_FEED_DATA', true)
    commit('SET_FEED_DATA_ERROR', null)
    
    // Format date like operational dashboard
    const formatDate = (isoString) => {
      if (!isoString) return '';
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return '';
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };
    
    // Prepare jsonData with queues and users
    const jsonData = JSON.stringify({
      queues: queues || [],
      users: users || []
    })
    
    // Get date type from state
    const dateType = state.dateType
    
    // Build query parameters according to API specification
    const params = new URLSearchParams({
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      byFeedDate: dateType === 'feed' ? 'true' : 'false',
      jsonData: jsonData,
      firstPercentage: (percentageSlice1 || 20).toString(),
      secondPercentage: (percentageSlice2 || 60).toString()
    })
    
    const endpoint = `api/Dashboard/GetOperationAnalysisAndReportingFeedData?${params.toString()}`
    
    const response = await utils.utility.fetch(endpoint, 'GET', null, null)
    const responseData = response.data || response
    
    commit('SET_FEED_REPORT_DATA', responseData)
    commit('SET_SELECTED_QUEUES', queues)
    commit('SET_SELECTED_USERS', users)
    commit('SET_SELECTED_DATE_RANGE', [startDate, endDate])
    commit('SET_LOADING_FEED_DATA', false)
    
    return { success: true, data: response }
  },
  
  // Load Available Queues (for dialog selection)
  async loadAvailableQueues({ commit }) {
    commit('SET_LOADING_QUEUES', true)
    
    const response = await utils.utility.fetch("api/workspace/getworkspacequeues", "GET", null, null)
    const responsePayload = response?.data || response
    const queueList = Array.isArray(responsePayload?.data)
      ? responsePayload.data
      : Array.isArray(responsePayload)
        ? responsePayload
        : []

    const allQueues = queueList.map((queue) => {
      const rawId = queue?.id ?? queue?.Id
      const parsedId = Number(rawId)

      return {
        ...queue,
        id: Number.isNaN(parsedId) ? rawId : parsedId,
        name: queue?.name ?? queue?.queueName ?? queue?.QueueName ?? ''
      }
    })
    
    commit('SET_AVAILABLE_QUEUES', allQueues)
    commit('SET_LOADING_QUEUES', false)
    
    return { success: true, data: allQueues }
  },
  
  // Load Available Users (for dialog selection)
  async loadAvailableUsers({ commit }) {
    commit('SET_LOADING_USERS', true)
    
    const response = await utils.utility.fetch('api/Dashboard/GetWorkspaceGroupsUsers', 'GET', null, null, true);
    const rawGroupData = response.data || response;
    
    commit('SET_GROUP_USERS', rawGroupData)
    
    const allUsers = [];
    if (Array.isArray(rawGroupData)) {
      rawGroupData.forEach(group => {
        if (group.groupUsers && Array.isArray(group.groupUsers)) {
          group.groupUsers.forEach(user => {
            if (!allUsers.find(u => u.id === user.userId)) {
              allUsers.push({
                id: user.userId,
                name: user.name,
                groupName: group.groupName
              });
            }
          });
        }
      });
    }
    
    commit('SET_AVAILABLE_USERS', allUsers)
    commit('SET_LOADING_USERS', false)
    
    return { success: true, data: allUsers }
  },
  
  // Update Selections (without reloading data)
  updateSelections({ commit }, { queues, users, dateType }) {
    commit('SET_SELECTED_QUEUES', queues || [])
    commit('SET_SELECTED_USERS', users || [])
    if (dateType !== undefined) {
      commit('SET_DATE_TYPE', dateType)
    }
  },
  
  // Update Date Type
  updateDateType({ commit }, dateType) {
    commit('SET_DATE_TYPE', dateType)
  },
  
  // Clear All Data
  clearFeedReportData({ commit }) {
    commit('CLEAR_FEED_REPORT_DATA')
    commit('SET_SELECTED_QUEUES', [])
    commit('SET_SELECTED_USERS', [])
    commit('SET_SELECTED_DATE_RANGE', [])
    commit('SET_DATE_TYPE', 'system')
  }
}